import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import InputBase from '@mui/material/InputBase';
import { doSearch, cancelSearch, searchMoreProducts, searchMoreCollections } from '../modules/search'
import {
  syncProductByShopifyId,
  syncCollectionByShopifyId,
  syncPageByShopifyId,
  syncArticleByShopifyId,
  syncBlogByShopifyId
} from '../modules/sync_by_shopify_id'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import CircularProgress from '@mui/material/CircularProgress';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import CollectionsIcon from '@mui/icons-material/CollectionsOutlined';
import LoadingIndicator from '../components/LoadingIndicator';
import Divider from '@mui/material/Divider';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { loadMetaObject, loadMetaObjects } from '../modules/metaObjects'
import { themeItemOf, THEME_SPLIT_STORAGE_KEY } from '../containers/new_theme';
import { UpgradePlanHintArea } from './PricingPlans';

const styles = {
  inputRoot: {
    color: 'inherit',
    width: '90%',
  },
  inputInput: (theme) => ({
    opacity: .7,
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  }),
  searchIcon: (theme) => ({
    width: theme.spacing(5),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    // starts where the navigation icons below start
    justifyContent: 'flex-start',
    top: 0,
    opacity: .5,
  }),
  closeIcon: (theme) => ({
    width: theme.spacing(5),
    height: '100%',
    position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    top: 0,
    opacity: .5,
  }),
  progressIcon: (theme) => ({
    width: theme.spacing(5),
    height: '100%',
    position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    top: 0,
  }),
  progressIconCircle: {
    width: '20px !important',
    height: '20px !important',
    color: 'text.primary',
    opacity: .5,
  },
  searchResults: {
    overflowY: 'auto',
    position: 'fixed',
    top: '64px',
    left: '240px',
    width: 300,
    height: 'calc(100vh - 64px)',
    backgroundColor: 'background.paper',
    borderRight: '1px solid',
    borderRightColor: 'divider',
  },
  black: {
    color: 'text.primary'
  },
  loadMore: {
    '&:hover': {
    backgroundColor: 'secondary.main',
    },
    '&:focus': {
    backgroundColor: 'secondary.main',
    },
    textAlign: "center",
    backgroundColor: 'secondary.main',
  },
  loadMoreText: {
    color: 'secondary.contrastText',
    fontSize: "0.875rem",
    fontWeight: "500"
  },
  subheader: {
    margin: "-10px"
  },
  noResults: {
    color: 'text.secondary',
    fontSize: "0.875rem",
    fontWeight: "500",
    textAlign: "center",
    paddingTop: "5px",
    position: "absolute",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  listSubheader: {
    lineHeight: '38px',
  },
  listItemText: {
    whiteSpace: 'normal',
  },
  lockedResult: {
    backgroundColor: '#ffaf23',
    color: '#3a20cd',
    cursor: 'default',
  },
};

class Search extends React.Component {
  constructor(props) {
    super(props)

    this.timer = null

    this.state = {
      query: '',
      opened: false,
      moreProductsAvailable: false,
      productsCursor: null,
      moreCollectionsAvailable: false,
      collectionsCursor: null,
      products: [],
      collections: [],
      pages: [],
      articles: [],
      blogs: [],
      metaobjects: [],
      theme: [],
      customContents: [],
      links: [],
      tags: [],
      types: [],
      vendors: []
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  }

  componentWillReceiveProps = newProps => {
    if (
      this.props.search.pending === true &&
      newProps.search.pending === false
    ) {
      const newProducts = []
      if (newProps.search.results.products) {
        newProps.search.results.products.results.forEach(result => {
          newProducts.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newCollections = []
      if (newProps.search.results.collections) {
        newProps.search.results.collections.results.forEach(result => {
          newCollections.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newPages = []
      if (newProps.search.results.pages) {
        newProps.search.results.pages.results.forEach(result => {
          newPages.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newArticles = []
      if (newProps.search.results.articles) {
        newProps.search.results.articles.results.forEach(result => {
          newArticles.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newBlogs = []
      if (newProps.search.results.blogs) {
        newProps.search.results.blogs.results.forEach(result => {
          newBlogs.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newMetaobjects = []
      if (newProps.search.results.metaobjects) {
        newProps.search.results.metaobjects.results.forEach(result => {
          newMetaobjects.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newTheme = []
      if (newProps.search.results.theme) {
        newProps.search.results.theme.results.forEach(result => {
          newTheme.push({
            id: result.id,
            fieldId: result.field_id,
            path: result.path,
            title: result.title
          })
        })
      }

      const newCustomContents = []
      if (newProps.search.results.custom_contents) {
        newProps.search.results.custom_contents.results.forEach(result => {
          newCustomContents.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newLinks = []
      if (newProps.search.results.links) {
        newProps.search.results.links.results.forEach(result => {
          newLinks.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newTags = []
      if (newProps.search.results.tags) {
        newProps.search.results.tags.results.forEach(result => {
          newTags.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newTypes = []
      if (newProps.search.results.types) {
        newProps.search.results.types.results.forEach(result => {
          newTypes.push({
            id: result.id,
            title: result.title
          })
        })
      }

      const newVendors = []
      if (newProps.search.results.vendors) {
        newProps.search.results.vendors.results.forEach(result => {
          newVendors.push({
            id: result.id,
            title: result.title
          })
        })
      }

      this.setState({
        moreProductsAvailable: newProps.search.results.products
          ? newProps.search.results.products.hasNextPage
          : false,
        productsCursor: newProps.search.results.products
          ? newProps.search.results.products.cursor
          : null,
        products: newProducts,
        pages: newPages,
        articles: newArticles,
        blogs: newBlogs,
        metaobjects: newMetaobjects,
        moreCollectionsAvailable: newProps.search.results.collections
          ? newProps.search.results.collections.hasNextPage
          : false,
        collectionsCursor: newProps.search.results.collections
          ? newProps.search.results.collections.cursor
          : null,
        collections: newCollections,
        theme: newTheme,
        customContents: newCustomContents,
        links: newLinks,
        tags: newTags,
        types: newTypes,
        vendors: newVendors
      })
    }

    if (
      this.props.syncByShopifyId.pending === true &&
      newProps.syncByShopifyId.pending === false
    ) {
      this.setState({
        opened: false,
        results: []
      })
      if (newProps.syncByShopifyId.result.type === 'product') {
        this.props.history.push(
          '/products/' + newProps.syncByShopifyId.result.id
        )
      } else if (newProps.syncByShopifyId.result.type === 'collection') {
        this.props.history.push(
          '/collections/' + newProps.syncByShopifyId.result.id
        )
      } else if (newProps.syncByShopifyId.result.type === 'page') {
        this.props.history.push('/pages/' + newProps.syncByShopifyId.result.id)
      } else if (newProps.syncByShopifyId.result.type === 'article') {
        this.props.history.push(
          '/articles/' + newProps.syncByShopifyId.result.id
        )
      } else if (newProps.syncByShopifyId.result.type === 'blog') {
        this.props.history.push('/blogs/' + newProps.syncByShopifyId.result.id)
      }
    }
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this)

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        opened: false
      })
    }
  }

  cancelSearch = () => {
    this.props.cancelSearch()
    this.setState({
      query: '',
      opened: false,
      moreProductsAvailable: false,
      productsCursor: null,
      moreCollectionsAvailable: false,
      collectionsCursor: null,
      products: [],
      collections: []
    })
  }

  openMobileSearch = () => {
    this.setState({
      opened: true
    })
  }

  onChange = event => {
    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.props.doSearch(this.props.theme, this.state.query)
    }, 500)
    //this.setState({})

    const query = event.target.value
    if (query.trim() === '') {
      this.cancelSearch()
    } else {
      this.setState({ opened: true, query: query })
    }
  }

  onClose = () => {
    this.cancelSearch()
  }

  onFocus = () => {
    this.setState({
      opened: true
    })
  }

  loadMoreProducts = () => {
    if (this.state.moreProductsAvailable && this.state.productsCursor) {
      this.props.searchMoreProducts(this.state.query, this.state.productsCursor)
    }
  }

  loadMoreCollections = () => {
    if (this.state.moreCollectionsAvailable && this.state.collectionsCursor) {
      this.props.searchMoreCollections(
        this.state.query,
        this.state.collectionsCursor
      )
    }
  }

  onClickProduct = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.syncProductByShopifyId(item.id)
  }

  onClickCollection = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.syncCollectionByShopifyId(item.id)
  }

  onClickPage = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.syncPageByShopifyId(item.id)
  }

  onClickArticle = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.syncArticleByShopifyId(item.id)
  }

  onClickBlog = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.syncBlogByShopifyId(item.id)
  }

  onClickMetaobject = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.loadMetaObject(
      item.id,
      this.props.editLanguage,
      this.handleMetaObjectExpanded
    )

    this.props.history.push('/metaobjects/' + item.id)
  }

  onClickTheme = item => {
    this.setState({
      opened: false,
      results: []
    })

    // the theme page decides from the split switch which item holds the string; the hash is the
    // field deeplink, which scrolls to the field and highlights it
    let split = false;
    try { split = localStorage.getItem(THEME_SPLIT_STORAGE_KEY) === 'true'; } catch(e) { /* storage blocked: no split */ }
    const { itemId } = themeItemOf(item.path, split);
    this.props.history.push('/theme/' + this.props.theme + '/' + itemId + (item.fieldId ? '#' + item.fieldId : ''))
  }

  onClickCustomContent = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.history.push('/custom/' + item.id)
  }

  onClickLink = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.history.push('/navigation/' + item.id)
  }

  onClickTag = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.history.push('/products/tags')
  }

  onClickType = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.history.push('/products/types')
  }

  onClickVendor = item => {
    this.setState({
      opened: false,
      results: []
    })

    this.props.history.push('/products/vendors')
  }

  render() {
    const { t } = this.props

    return (
      <div>
        <Box sx={styles.searchIcon}>
          <SearchIcon sx={{ fontSize: 20 }} />
        </Box>
        <div className="mobile-trigger" onClick={this.openMobileSearch} />
        <div className="form-wrap">
          {this.state.opened && !this.props.search.pending ? (
            <Box className='close-btn' sx={styles.closeIcon}>
              <CloseIcon onClick={this.onClose} />
            </Box>
          ) : null}
          {this.state.opened && this.props.search.pending ? (
            <Box sx={styles.progressIcon}>
              <CircularProgress sx={styles.progressIconCircle} />
            </Box>
          ) : null}

          <InputBase
            placeholder={t('search.placeholder')}
            value={this.state.query}
            onChange={this.onChange}
            onFocus={this.onFocus}
            sx={{
              '&.MuiInputBase-root': styles.inputRoot,
              '& .MuiInputBase-input': styles.inputInput,
            }}
          />
        </div>
        {this.state.opened && (
          <React.Fragment>
            <List
              subheader={
                <React.Fragment>
                  <ListSubheader />
                  <Divider />
                </React.Fragment>
              }
              component="nav"
              aria-labelledby="nested-list-subheader"
              sx={styles.searchResults}>
              <div className="form-wrap-mobile">
                {this.state.opened && !this.props.search.pending ? (
                  <Box className='close-btn' sx={styles.closeIcon}>
                    <CloseIcon onClick={this.onClose} />
                  </Box>
                ) : null}
                {this.state.opened && this.props.search.pending ? (
                  <Box sx={styles.progressIcon}>
                    <CircularProgress sx={styles.progressIconCircle} />
                  </Box>
                ) : null}

                <InputBase
                  placeholder="Search…"
                  value={this.state.query}
                  onChange={this.onChange}
                  onFocus={this.onFocus}
                  sx={{
                    '&.MuiInputBase-root': styles.inputRoot,
                    '& .MuiInputBase-input': styles.inputInput,
                  }}
                />
              </div>
              {this.state.products.length <= 0 &&
              this.state.collections.length <= 0 &&
              this.state.pages.length <= 0 &&
              this.state.articles.length <= 0 &&
              this.state.metaobjects.length <= 0 &&
              this.state.theme.length <= 0 &&
              this.state.customContents.length <= 0 &&
              this.state.links.length <= 0 ? (
                <Box sx={styles.noResults}>
                  {t('search.noResultsMsg')}
                </Box>
              ) : null}

              {this.state.products.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.products')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.products.map((item, n) => {
                return (
                  <React.Fragment key={`search-product-${n}`}>
                    <ListItem button onClick={() => this.onClickProduct(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}
              {this.state.moreProductsAvailable ? (
                <ListItem
                  button
                  sx={styles.loadMore}
                  onClick={this.loadMoreProducts}>
                  <ListItemText
                    sx={{'& .MuiListItemText-primary': styles.loadMoreText}}
                    primary={t('search.loadMoreProducts')}
                  />
                </ListItem>
              ) : null}

              {this.state.collections.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.collections')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.collections.map((item, n) => {
                return (
                  <React.Fragment key={`search-collection-${n}`}>
                    <ListItem
                      button
                      onClick={() => this.onClickCollection(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}
              {this.state.moreCollectionsAvailable ? (
                <ListItem
                  button
                  sx={styles.loadMore}
                  onClick={this.loadMoreCollections}>
                  <ListItemText
                    sx={{'& .MuiListItemText-primary': styles.loadMoreText}}
                    primary={t('search.loadMoreCollections')}
                  />
                </ListItem>
              ) : null}

              {this.state.pages.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.pages')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.pages.map((item, n) => {
                return (
                  <React.Fragment key={`search-page-${n}`}>
                    <ListItem button onClick={() => this.onClickPage(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.articles.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.articles')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.articles.map((item, n) => {
                return (
                  <React.Fragment key={`search-article-${n}`}>
                    <ListItem button onClick={() => this.onClickArticle(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.blogs.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.blogs')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.blogs.map((item, n) => {
                return (
                  <React.Fragment key={`search-blog-${n}`}>
                    <ListItem button onClick={() => this.onClickBlog(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.metaobjects.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.metaobjects')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.metaobjects.map((item, n) => {
                return (
                  <React.Fragment key={`search-metaobject-${n}`}>
                    <ListItem
                      button
                      onClick={() => this.onClickMetaobject(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.theme.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.theme')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.theme.map((item, n) => {
                return (
                  <React.Fragment key={`search-product-${n}`}>
                    <ListItem button onClick={() => this.onClickTheme(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.customContents.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={[styles.listSubheader, this.props.shopPlan === 'free' && styles.lockedResult]}>
                    {t('search.customContent')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.customContents.map((item, n) => {
                return (
                  <React.Fragment key={`search-collection-${n}`}>
                    {/* the free plan finds custom contents but cannot open them: the result says so
                        instead of leading to the plans page */}
                    {this.props.shopPlan === 'free' ?
                      <UpgradePlanHintArea placement="right" neededPlan="basic" features={[t('plans.customContentDummy.feature1'), t('plans.customContentDummy.feature2'), t('plans.customContentDummy.feature3')]}>
                        <ListItem sx={styles.lockedResult}>
                          <ListItemText
                            primary={item.title}
                            sx={styles.listItemText}
                          />
                        </ListItem>
                      </UpgradePlanHintArea>
                    :
                      <ListItem
                        button
                        onClick={() => this.onClickCustomContent(item)}>
                        <ListItemText
                          primary={item.title}
                          sx={styles.listItemText}
                        />
                      </ListItem>
                    }
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.links.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.navigation')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.links.map((item, n) => {
                return (
                  <React.Fragment key={`search-link-${n}`}>
                    <ListItem button onClick={() => this.onClickLink(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.tags.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.tags')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.tags.map((item, n) => {
                return (
                  <React.Fragment key={`search-tag-${n}`}>
                    <ListItem button onClick={() => this.onClickTag(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.types.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.types')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.types.map((item, n) => {
                return (
                  <React.Fragment key={`search-type-${n}`}>
                    <ListItem button onClick={() => this.onClickType(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}

              {this.state.vendors.length > 0 ? (
                <React.Fragment>
                  <ListSubheader sx={styles.listSubheader}>
                    {t('search.vendors')}
                  </ListSubheader>
                  <Divider />
                </React.Fragment>
              ) : null}
              {this.state.vendors.map((item, n) => {
                return (
                  <React.Fragment key={`search-vendor-${n}`}>
                    <ListItem button onClick={() => this.onClickVendor(item)}>
                      <ListItemText
                        primary={item.title}
                        sx={styles.listItemText}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )
              })}
            </List>
          </React.Fragment>
        )}
        <LoadingIndicator
          pending={this.props.syncByShopifyId.pending}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ search, syncByShopifyId, shop }) => ({
  search: search,
  syncByShopifyId: syncByShopifyId,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge?.name,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      doSearch,
      cancelSearch,
      searchMoreProducts,
      searchMoreCollections,
      syncProductByShopifyId,
      syncCollectionByShopifyId,
      syncPageByShopifyId,
      syncArticleByShopifyId,
      syncBlogByShopifyId,
      loadMetaObject
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Search)))
